import request from '@/utils/request'
// 登录
// export function login(username, password) {
//   return request({
//     url: 'Shop.User/login',
//     // url: '/admin/login',
//     method: 'post',
//     data: {
//       username,
//       password
//     }
//   })
// }

// 登录
export function login(data) {
  return request({
    url: 'Shop.User/senlogs',
    method: 'post',
    data: data
  })
}

// 用户信息
export function getInfo() {
  return request({
    url: 'Shop.User/info',
    method: 'get',
  })
}

// 微信二维码绑定接口
export function wechatBind(data) {
  return request({
    url: 'Shop.User/wechat_bind',
    method: 'post',
    data: data
  })
}
// 微信二维码登录接口
export function qrcodeLogin(data) {
  return request({
    url: 'Shop.User/qrcode_login',
    method: 'post',
    data: data
  })
}

// 退出
export function logout() {
  return request({
    url: 'Shop.User/logout',
    method: 'post'
  })
}
// 个人中心列表
export function fetchList(params) {
  return request({
    url: 'Shop.User/index',
    method: 'get',
    params: params
  })
}
// 添加
export function createAdmin(data) {
  return request({
    url: 'Shop.User/add',
    method: 'post',
    data: data
  })
}
// 修改
export function updateAdmin(data) {
  return request({
    url: 'Shop.User/son_account',
    method: 'post',
    data: data
  })
}

// 删除
export function deleteAdmin(data) {
  return request({
    url: 'Shop.User/delete',
    method: 'post',
    data: data
  })
}

// 编辑资料
export function update( data) {
  return request({
    url: 'Shop.User/update',
    method: 'post',
    data: data
  })
}
// 验证密码
export function checkpassword(data) {
  return request({
    url: 'Shop.User/checkpassword',
    method: 'post',
    data: data
  })
}
// 修改密码
export function updatePassword(data) {
  return request({
    url: 'Shop.User/updatePassword',
    method: 'post',
    data: data
  })
}
// 上传图片
export function uploadpicture(data) {
  return request({
    url: 'Shop.User/uploadpicture',
    method: 'post',
    data: data
  })
}

// 采购统计年度进货额退货额比例
export function purYearBuyBack(params) {
  return request({
    url: 'Shop.Report/pur_year_buy_back',
    method: 'get',
    params: params
  })
}

// 采购年度进货按月统计
export function purYearBuyMonth(params) {
  return request({
    url: 'Shop.Report/pur_year_buy_month',
    method: 'get',
    params: params
  })
}
// 记事本列表
export function NotebookList(params) {
  return request({
    url: 'Shop.Notebook/index',
    method: 'get',
    params: params
  })
}
// 添加记事本
export function addNotebook(params) {
  return request({
    url: 'Shop.Notebook/add',
    method: 'get',
    params: params
  })
}
// 回复记事本
export function updateNotebook(params) {
  return request({
    url: 'Shop.Notebook/update',
    method: 'get',
    params: params
  })
}
// 删除记事本
export function deleteNotebook(data) {
  return request({
    url: 'Shop.Notebook/delete',
    method: 'post',
    data: data
  })
}
// 编辑记事本
export function editNotebook(params) {
  return request({
    url: 'Shop.Notebook/edit',
    method: 'get',
    params: params
  })
}

// 微信支付开通市场价格权限
export function wepayfor_marketprice(params) {
  return request({
    url: 'Shop.Accessories/wepayfor_marketprice',
    method: 'get',
    params: params
  })
}
// 查询支付订单状态
export function querypo(data) {
  return request({
    url: 'Pay.WxPay/querypo',
    method: 'post',
    data: data
  })
}
// 首页弹窗 是否不再提醒
export function setPopup(params) {
  return request({
    url: 'Shop.User/popup',
    method: 'get',
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/login.js